const Users = () => import(/* webpackChunkName: "system" */ '@/pages/users');
const UserLogs = () => import(/* webpackChunkName: "system" */ '@/pages/userLogs');
const Scopes = () => import(/* webpackChunkName: "system" */ '@/pages/scopes');
const Roles = () => import(/* webpackChunkName: "system" */ '@/pages/roles');
const Companies = () => import(/* webpackChunkName: "system" */ '@/pages/companies');
const ServiceSettings = () => import(/* webpackChunkName: "system" */ '@/pages/serviceSettings');
const Menus = () => import(/* webpackChunkName: "system" */ '@/pages/menus');

export default [
  {
    path: 'system/scopes',
    name: 'System  /  Scopes',
    component: Scopes,
  },
  {
    path: 'system/roles',
    name: 'System  /  Roles',
    component: Roles,
  },
  {
    path: 'system/users',
    name: 'System  /  Users',
    component: Users,
  },
  {
    path: 'system/userlogs',
    name: 'System  /  User logs',
    component: UserLogs,
  },
  {
    path: 'system/companies/:company_id?',
    name: 'System  /  Companies',
    component: Companies,
  },
  {
    path: 'serviceSettings',
    name: 'Service Settings',
    component: ServiceSettings,
  },
  {
    path: 'appearance/menus',
    name: 'Appearance  /  Menus',
    component: Menus,
  },
];
